import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row pt-4" }
const _hoisted_5 = { class: "col col-12 offset-md-3 col-md-6 text-start irx-col pb-0" }
const _hoisted_6 = { class: "irx-wrapper" }
const _hoisted_7 = { class: "col col-12 col-md-6 text-start grx-col" }
const _hoisted_8 = { class: "grx-wrapper" }
const _hoisted_9 = { class: "col col-12 col-md-6 text-start irx-col" }
const _hoisted_10 = { class: "irx-wrapper" }
const _hoisted_11 = { class: "col col-12 col-md-6 text-start irx-col" }
const _hoisted_12 = { class: "irx-wrapper" }
const _hoisted_13 = { class: "col col-12 col-md-6 text-start irx-col" }
const _hoisted_14 = { class: "irx-wrapper" }
const _hoisted_15 = { class: "col col-12 col-md-6 text-start grx-col" }
const _hoisted_16 = { class: "grx-wrapper" }
const _hoisted_17 = { class: "col col-12 col-md-6 text-start irx-col" }
const _hoisted_18 = { class: "irx-wrapper" }
const _hoisted_19 = { class: "col col-12 col-md-6 text-start grx-col" }
const _hoisted_20 = { class: "grx-wrapper" }
const _hoisted_21 = { class: "col col-12 col-md-6 text-start irx-col" }
const _hoisted_22 = { class: "irx-wrapper" }
const _hoisted_23 = {
  key: 1,
  class: "background-slanted-primary-negative-margin"
}
const _hoisted_24 = { class: "background-slanted-primary text-light row pb-3" }
const _hoisted_25 = { class: "container" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  class: "text-center fw-bold pt-5",
  style: {"text-transform":"capitalize"}
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  class: "text-center fw-bold",
  style: {"text-transform":"capitalize"}
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  key: 0,
  class: "row align-items-center"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "col col-6 align-self-center" }
const _hoisted_36 = { class: "drug-name text-center text-light" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "row justify-content-center" }
const _hoisted_39 = { class: "container" }
const _hoisted_40 = { class: "pt-4" }
const _hoisted_41 = {
  class: "modal fade",
  id: "goodrxScreenshotModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "goodrxScreenshotModalTitle",
  "aria-hidden": "true"
}
const _hoisted_42 = {
  class: "modal-dialog modal-dialog-centered modal-xl",
  role: "document"
}
const _hoisted_43 = { class: "modal-content" }
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "container-fluid" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "modal-header" }
const _hoisted_49 = {
  class: "modal-title",
  id: "goodrxScreenshotModalTitle",
  style: {"text-transform":"capitalize"}
}
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col col-12" }
const _hoisted_52 = ["href"]
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col col-12" }
const _hoisted_55 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_goodrx_comparison_links = _resolveComponent("goodrx-comparison-links")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (this.drugName == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col col-12" }, [
                _createElementVNode("div", { class: "text-center pt-4 pb-4" }, [
                  _createElementVNode("h1", null, "GoodRx vs. IntelligentRx Coupons 2022")
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-dollar-sign",
                    style: {"color":"green"},
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "" }, " IntelligentRx Has Better Prices at Many Pharmacies ", -1)),
                  _createElementVNode("p", null, [
                    _cache[4] || (_cache[4] = _createTextVNode(" IntelligentRx has better prices in 4 of the largest pharmacies (including CVS and Walgreens). ", -1)),
                    _createVNode(_component_router_link, { to: "/goodrx-comparison/#betterPrices" }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Learn more here", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[5] || (_cache[5] = _createTextVNode(" or compare a price with our ", -1)),
                    _createVNode(_component_router_link, { to: "/goodrx-comparison/#goodrx-comparison" }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("price comparison tool", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createTextVNode(" or look up any IntelligentRx price below. ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-circle-info",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "" }, "GoodRx Has Better Drug Information", -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("p", null, " Medicare coverage (or lack thereof); Drug Info; Side Effects; Images of the drugs: GoodRx has lots of resources to help you learn more about a particular drug. IntelligentRx does not provide any of these services; instead using a no-frills approach to finding prescription savings. ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-hospital-user",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "" }, "IntelligentRx Is Better for Pharmacies", -1)),
                  _createElementVNode("p", null, [
                    _cache[11] || (_cache[11] = _createTextVNode(" IntelligentRx charges pharmacies less, helping you save more. ", -1)),
                    _createVNode(_component_router_link, { to: "/goodrx-comparison/#betterForPharmacies" }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("Learn More", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-rectangle-ad",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "" }, "IntelligentRx Has No Ads", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("p", null, " IntelligentRx does not have ads anywhere on its website or apps, and we have no itention of adding any. GoodRx has a few rectangular ad blocks served from Google Ads and also has product placement, which tries to upsell you on various GoodRx and partner services. ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-tags",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "" }, "IntelligentRx Can Show GoodRx Prices", -1)),
                  _createElementVNode("p", null, [
                    _cache[16] || (_cache[16] = _createTextVNode(" We have catalogued and compared the most common GoodRx price in its default label/form/dosage/quantity to the IntelligentRx price in our GoodRx comparison to help you better understand the different prices available. ", -1)),
                    _createVNode(_component_router_link, { to: "/goodrx-comparison/#goodrx-comparison" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("Learn more", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[17] || (_cache[17] = _createTextVNode(". ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-building",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "" }, "GoodRx has more than 12 PBMs", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("p", null, " According to GoodRx's investor disclosures, they partner with \"more than 12\" PBMs to provide the discount pricing you see on their website. The PBMs are mostly traditional PBMs, although GoodRx also uses some flat fee PBMs too. ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-building",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "" }, "IntelligentRx has 12 PBMs", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("p", null, " IntelligentRx partners with exactly 12 PBMs to provide prices. All of our PBMs were chosen because of their transparent nature - they were willing to share how much money they make on specific medications with us. We require this disclosure to ensure they are passing prescription savings on to consumers. ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-lock-open",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "" }, "GoodRx sold Patient Data", -1)),
                  _cache[24] || (_cache[24] = _createElementVNode("p", null, [
                    _createTextVNode(" GoodRx receives information like your name, sex, date of birth, and the medication you are taking. They used this to "),
                    _createElementVNode("a", { href: "https://www.consumerreports.org/health-privacy/goodrx-saves-money-on-medsit-also-shares-data-with-google-facebook-and-others-a6177047589/" }, "they share that information with third parties"),
                    _createTextVNode(" to advertise products to you based on your medical condition(s). It is also possible that their PBM partners sell the data they receive from pharmacies. ")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "d-none d-md-block m-auto pb-3",
                    icon: "fa fa-lock",
                    size: "3x",
                    "aria-hidden": "true"
                  }),
                  _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "" }, "IntelligentRx does Not Sell Your Data", -1)),
                  _cache[26] || (_cache[26] = _createElementVNode("p", null, " IntelligentRx does not sell our data to anyone. That being said, it is possible that our PBM partners sell the data they receive from pharamcies. ", -1))
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[28] || (_cache[28] = [
            _createElementVNode("p", null, " ", -1)
          ]))]))
    ]),
    ($data.showSpinner)
      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        (this.drugName == null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[29] || (_cache[29] = [
              _createStaticVNode("<h2 id=\"betterPrices\" data-v-64b63762>How IntelligentRx has Better Prices</h2><p data-v-64b63762><b data-v-64b63762>Short answer:</b> We make less money.</p><p data-v-64b63762><b data-v-64b63762>Long answer:</b> Both GoodRx and IntelligentRx work by connecting consumers to a third party called a PBM which issues prescription discounts. This third party negotiates discounts and we help you get access to those discounts. When you pay for a drug at a pharmacy with a prescription discount coupon, part of the payment goes to the pharmacy and part of the payment goes to the PBM. Both IntelligentRx and GoodRx receive a cut of the PBM&#39;s payment when you use one of our coupons. IntelligentRx can provide lower prices for the same coupon because we receive a smaller cut than GoodRx. Unfortunately, it&#39;s not as simple as, &quot;IntelligentRx is always better because we take a smaller cut&quot;. IntelligentRx and GoodRx&#39;s PBMs are different, which means we have access to different discounts, which in turn means sometimes GoodRx has access to better discount pricing than IntelligentRx. We are always working to add more PBMs to get better prices. </p><p data-v-64b63762> Our pricing analysis was conducted with about 310 of the highest volume prescription drugs (~2% of high-volume drugs were excluded). For each drug, we took a screenshot of GoodRx’s website and then compared those prices to IntelligentRx prices. We found that IntelligentRx has the better price X% of the time at different pharmacies: 97% / Kroger; 71% / Walgreens; 66% / Rite Aid; 61% / CVS; 47% / Walmart; 46% / Albertsons; 32% / Costco. Obviously, the Kroger analysis is questionable due to the GoodRx-Kroger debacle, but our savings at the biggest pharmacy chains - CVS and Walgreens - and our prices at other pharmacies are superior or comparable. Suffice to say, IntelligentRx’s prices are great! But there are other reasons to use our service too. </p><h2 id=\"betterForPharmacies\" data-v-64b63762> How IntelligentRx is Better for Pharmacies </h2><p data-v-64b63762><b data-v-64b63762>Short answer:</b> IntelligentRx Charges Pharmacies Less</p><p data-v-64b63762><b data-v-64b63762>Long answer:</b> GoodRx does not release data regarding how much they charge pharmacies so we do not know their exact claim information. However, we know our numbers and can share them with you because we have transparent PBM contracts! Our most popular discount (we have 12 PBM partners, so we&#39;ll focus on this one for brevity) charges an average pharmacy <b data-v-64b63762>$3.45 per claim</b> if we get paid. At CVS, our average paid claim is $27.25. We think GoodRx&#39;s average paid claim is larger because they have worse prices, but I digress. Let&#39;s assume GoodRx&#39;s PBMs are seeing average paid claims of $27.25. GoodRx has stated on their public investor disclosures that they receive 15% on most transactions, and drugchannels.net suggests that the PBM might take 5%, so let&#39;s say 15% + 5% = 20% of the paid claim goes to the PBM + GoodRx. With an average paid claim of 27.25, pharmacies pay 27.25 * .2 = <b data-v-64b63762>$5.45 per claim</b>. What does all this mean? Why should you care? We believe this means IntelligentRx costs pharmacies 2 dollars less than GoodRx on a typical prescription fill; therefore it&#39;s better for the pharmacies to use IntelligentRx; and this helps IntelligentRx be accepted at more pharmacies. </p>", 7)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("h1", _hoisted_28, _toDisplayString($data.drugName) + " Price Comparison", 1),
              (this.prices == null || this.prices.length < 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Sorry, but no up to date price comparison is available for " + _toDisplayString($data.drugName) + " right now. ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    ($data.drugNameInCoupons != null)
                      ? (_openBlock(), _createElementBlock("h2", _hoisted_31, " (prices for " + _toDisplayString($data.drugNameInCoupons) + ") ", 1))
                      : _createCommentVNode("", true),
                    _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"row d-md-flex d-none\" data-v-64b63762><div class=\"col col-3\" data-v-64b63762><h4 class=\"text-center\" data-v-64b63762>GoodRx</h4></div><div class=\"col col-3 offset-6\" data-v-64b63762><h4 class=\"text-center\" data-v-64b63762>IntelligentRx</h4></div></div><div class=\"row d-md-none d-flex\" data-v-64b63762><div class=\"col col-6\" data-v-64b63762><h4 class=\"text-start\" data-v-64b63762>GoodRx</h4></div><div class=\"col col-6\" data-v-64b63762><h4 class=\"text-start\" data-v-64b63762>IntelligentRx</h4></div></div>", 2)),
                    _createElementVNode("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.prices, (price, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col col-12 py-1"
                        }, [
                          (price.intelligentRx != null &&
                                    price.intelligentRx > 0 &&
                                    price.goodRx != null
                                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("a", {
                                  class: "col col-3 text-center align-self-center",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#goodrxScreenshotModal",
                                  onClick: ($event: any) => {
                                        $data.screenshotSrc = price.goodRxScreenshot;
                                        $data.screenshotURL = price.goodRxURL;
                                        },
                                  style: {"cursor":"pointer"}
                                }, _toDisplayString(price.goodRx > 0 ? price.goodRx : '?'), 9, _hoisted_34),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_36, _toDisplayString(price.pharmacy), 1)
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  class: "col col-3 btn btn-light comparison-drug-price text-center",
                                  onClick: ($event: any) => ($options.navigateToCoupon(price)),
                                  style: {"border-radius":"30px","font-weight":"bold"}
                                }, " $" + _toDisplayString(price.intelligentRx), 9, _hoisted_37)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("button", {
                        class: "col col-8 my-2 btn btn-light",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.navigateToSearch())),
                        style: {"border-radius":"30px","font-weight":"bold"}
                      }, " See More Pharmacies "),
                      _createElementVNode("button", {
                        class: "col col-12 col-md-8 my-2 btn btn-light",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.navigateToSearch())),
                        style: {"border-radius":"30px","font-weight":"bold"}
                      }, " Specify Label / Form / Dosage / Quantity ")
                    ])
                  ]))
            ]))
      ]),
      _cache[33] || (_cache[33] = _createElementVNode("hr", {
        class: "w-100",
        style: {"background-color":"white"}
      }, null, -1)),
      _createVNode(_component_goodrx_comparison_links, { id: "goodrx-comparison" }),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("p", _hoisted_40, " These statistics are compiled for " + _toDisplayString(this.numDrugsInComparison) + " of the most common drugs in their most common generic labels, forms, dosages, and quantities. Drug costs are pulled from the IntelligentRx and GoodRx websites. Drug prices change, so it is not possible to say with certainty that IntelligentRx is always better than GoodRx. The numbers seen here represent a snapshot of prices on IntelligentRx.com and GoodRx.com when this report was created in July 2022. ", 1),
        _createElementVNode("p", null, [
          _cache[32] || (_cache[32] = _createTextVNode(" Did you find this page helpful? If so, ", -1)),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "light-link"
          }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode("please let us know!", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("h5", _hoisted_49, _toDisplayString($data.drugName), 1),
                    _cache[34] || (_cache[34] = _createElementVNode("button", {
                      type: "button",
                      class: "btn-close",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }, null, -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("a", { href: $data.screenshotURL }, "Retrieved from GoodRx", 8, _hoisted_52)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("img", {
                    class: "img-fluid",
                    src: $data.screenshotSrc,
                    alt: "Screenshot of GoodRx website showing prices for this drug"
                  }, null, 8, _hoisted_55)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}